import CabinetCertificates from '@/apps/CabinetCertificates'
import Layout from '@/apps/layout/components'
import CabinetLayout from '@/apps/layout/components/CabinetLayout'
import React from 'react'

const CabinetCertificatesPage = (): React.ReactElement => {
  return (
    <Layout>
      <CabinetLayout>
        <CabinetCertificates />
      </CabinetLayout>
    </Layout>
  )
}

export default CabinetCertificatesPage
